import { render, staticRenderFns } from "./SpecimenTemperamentsTrackingModal.vue?vue&type=template&id=3ee5719f"
import script from "./SpecimenTemperamentsTrackingModal.vue?vue&type=script&lang=js"
export * from "./SpecimenTemperamentsTrackingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports